import { Typography } from '@mui/material'
import { segmentsFor } from '@/utils/segments'

const SegmentCounter = ({ body }: { body: string }) => {
  const info = segmentsFor(body)
  const messages = info.segments === 1 ? 'הודעה אחת' : `${info.segments} הודעות`
  return (
    <Typography
      variant="caption"
      sx={{ direction: 'rtl', display: 'block', color: 'text.secondary' }}
    >
      {`${info.chars} תווים${info.hasVariables ? ' (לא כולל משתנים)' : ''} · ${info.segments === 0 ? '0 הודעות' : messages}`}
      {info.hasVariables && ' · אומדן: ההודעה כוללת משתנים.'}
    </Typography>
  )
}

export default SegmentCounter
